module.exports = __webpack_public_path__ + "static/media/blog-icon.f6f05810.svg";